import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";

export const InheritDocumentsResultWrapper = styled.div`
  margin: 20px 0px 40px;

  ${responsive.MOBILE`
      margin: 20px 0px 0px;
    `}

  .form-header {
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;

    ${responsive.MOBILE`
        padding: 10px 8px;
      `}
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiPaper-root.MuiTableContainer-root {
    border-radius: 0;
  }

  .MuiGrid2-root {
    width: 100%;
  }
  .document-name-link {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .cell-city-type {
    min-width: 200px;
  }

  .selected-count {
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_black7};
    padding: 2px 9px 4px 9px;
    border-radius: 8px;
    margin-left: 8px;
    height: 28px;
  }
`;
